export default __webpack_public_path__ + "static/media/join-now-img.6c1867a5.png";